import { Component, OnInit } from '@angular/core';
import { ThemeList, ThemeService } from "@core/services/theme";
import { defaults } from "lodash";
// angular18 不支持组件中直接import 外部JS
// import "@assets/particles/waves.js";

declare const Waves: any;

@Component({
  standalone: true,
  selector: 'app-waves-js',
  templateUrl: './waves-js.component.html',
  styleUrls: ['./waves-js.component.less']
})
export class WavesJsComponent implements OnInit {

  private readonly smallScreenQuery = '(max-width: 768px), (pointer: coarse) and (max-width: 1024px)';

  private wave!: any;
  constructor(private themeService: ThemeService) {}

  ngOnInit(): void {
    this.themeService.currentTheme$.subscribe(theme => {
      this.loadWaves(theme === ThemeList.NIQLight ? {
        hue: [44, 44],
        step: 0,
        bgColor: '#fff'
      } : {
        hue: [14, 14],
        step: 2,
        bgColor: '#000'
      });
    });
  }

  loadWaves(config: any) {
    const element = document.getElementById('holder');
    while (element?.firstChild) {
      element.removeChild(element.firstChild);
    }
    if (this.isSmallScreen()) {
      return;
    }
    this.wave = new Waves('#holder', defaults(config, {
      waves: 3,
      width: 300,
    }));
    this.wave.animate();
  }

  private isSmallScreen(): boolean {
    return typeof window !== 'undefined' && (window.matchMedia?.(this.smallScreenQuery).matches || window.innerWidth <= 768);
  }

}
